var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tr-static-text"},_vm._l((_vm.parseText),function(item,index){return _c('tr-text',{key:index,attrs:{"text":item.value,"type":item.katex}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }